import variables from 'common/config/variables';
import { TestableComponent } from 'common/interfaces';
import { getScalablePixel } from 'common/utils';
import React from 'react';
import Button, { ButtonProps } from './Button';
const {
  background_color_c,
  background_color_dark,
  background_color_light,
  background_color_white
} = variables;

interface DefaultButtonProps extends TestableComponent {
  size?: ButtonProps['size'];
  title: ButtonProps['title'];
  icon?: ButtonProps['icon'];
  className?: ButtonProps['className'];
  onEnterPress?: ButtonProps['onEnterPress'];
  disabled?: ButtonProps['disabled'];
  onFocus?: ButtonProps['onFocus'];
  focusKey?: ButtonProps['focusKey'];
  fitContainer?: ButtonProps['fitContainer'];
  textTransform?: ButtonProps['textTransform'];
  disableMargin?: boolean;
  initiallyFocused?: ButtonProps['initiallyFocused'];
}
function DefaultButton(props: DefaultButtonProps) {
  return (
    <Button
      size="medium"
      {...props}
      focusBackgroundColor={background_color_c}
      backgroundColor={background_color_light}
      focusColor={background_color_dark}
      color={background_color_white}
      fontWeight={700}
      margin={props.disableMargin ? undefined : getScalablePixel(8)}
      testId={props.testId}
    />
  );
}

export default React.memo(DefaultButton);
